// extracted by mini-css-extract-plugin
module.exports = {"color-danger":"login_color-danger_3SLkj","color-success":"login_color-success_2Obd_","logInView":"login_logInView_3wfeh","or":"login_or_K-8l8","actions":"login_actions_mRpIn"};